/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFeather(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.22 3.224a6.753 6.753 0 019.551 9.55l-2.666 2.674a.756.756 0 01-.158.16l-3.915 3.926a.75.75 0 01-.531.22H5.31l-2.78 2.78a.75.75 0 01-1.06-1.06l2.78-2.78v-8.19a.75.75 0 01.22-.53l6.75-6.75zm-4.408 15.03h6.378l2.492-2.5h-6.37l-2.5 2.5zm4-4l5.72-5.72a.75.75 0 10-1.062-1.06l-9.72 9.72v-6.38l6.531-6.53a5.253 5.253 0 117.43 7.43l-2.533 2.54H10.81z'
      />
    </svg>
  );
}

export default SvgFeather;
